const index = () => import(/* webpackChunkName: "herb" */ './Index');

export default {
  routes: [
    //项目
    {
      path: '/internetDouble/2019/index',
      name: 'internetDouble2019Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/internet/double/v2019/router.js